module.exports = __webpack_public_path__ + "img/impression.93cf548a.svg";